/* eslint-disable no-secrets/no-secrets */
import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Grid } from '@jutro/layout';
import './MediaSideBar.messages';
import { withAuthenticationContext, useAuthentication } from '@xengage/gw-digital-auth-react';
import { MLPortalSettingsService } from 'gw-capability-quoteandbind';
import mediaSidebarStyles from './MediaSideBar.module.scss';
import FacebookPageComponent from '../FacebookPageComponent/FacebookPageComponent';
import YoutubeComponent from '../YoutubeComponent/YoutubeComponent';
import TwitterComponent from '../TwitterComponent/TwitterComponent';
import ContactComponent from '../ContactComponent/ContactComponent';
import TextComponent from '../TextComponent/TextComponent';
import RssDirective from '../Directives/RssDirective/RssDirective';
import MLSidebarLinks from '../../ml-components-platform-react/MLSidebarLinks/MLSidebarLinks';
import MLSidebarContactSection from '../../ml-components-platform-react/MLSidebarContactSection/MLSidebarContactSection';
// eslint-disable-next-line import/order, import/no-unresolved
import appConfig from 'app-config';

function MediaSideBar(props) {
    let linksToRender = [];
    let metlifeGASectionToRender;
    let arsUWSectionToRender;
    let claimsSectionToRender;
    let commiSectionToRender;
    let uwSectionToRender;
    const [arsUrl, setArsUrl] = useState()
    const [isMFALinkAdded, setIsMFALinkAdded] = useState(false)

    const {
        showContact,
        authUserData
    } = props;

    const {
        enabled, Facebook, Rss, Contact, Text, Twitter, Youtube, MLSidebar
    } = appConfig.mediaSidebar;

    const {
        MLUserTypes, runtimeEnv
    } = appConfig;

    const { authHeader } = useAuthentication();

    const updateLinks = (newUrl) => {
        if (arsUrl && linksToRender.length > 0) {
            const linkToRender = linksToRender.find((link) => {
                return link.link.name.id === 'ml_sidebar.text.sections.media_sidebar.link1';
            });
            if (linkToRender) {
                linkToRender.link.url = newUrl;
            }
        }
    };

    useEffect(() => {
        const getSettingsData = async () => {
            let settings = {};
            try {
                settings = await MLPortalSettingsService.getSettings(authHeader, true);
                setArsUrl(settings?.arsSettings?.arsUrl)
            } catch (e) { console.error(e) }

        };        
        
        getSettingsData();

        // Disabling to prevent continues re-rendering
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const updateSupplySourceLinkForLowerEnv = () => {
        if (runtimeEnv !== 'prod') {
            const supplySourceLink = linksToRender.find((link) => link.link.name.id === 'ml_sidebar.text.sections.media_sidebar.supply_source_link');
            
            if (supplySourceLink) {
                supplySourceLink.link.url = 'https://fwsia.oktapreview.com/app/fwsia_supplysourceqa_1/exk3m4ep13Oj4txPv1d7/sso/saml';
            }
        }
    };

    const addMFALink = (links) => {
        if (!isMFALinkAdded) {
            const JWTToken=JSON.stringify(authHeader);
            const token = JSON.parse(JWTToken).Authorization;
            const base64Url = token.split(".")[1];
            const base64 = base64Url.replace("-", "+").replace("_", "/");
            const result = JSON.parse(window.atob(base64));

            const url = (runtimeEnv === 'prod') 
                ? 'https://fwsia.okta.com/oauth2/ausbxbj3v1dF3acJB697/v1/authorize?client_id=0oabuf5sg1A3KjI4E697&response_type=code&scope=mfa%20openid%20offline_access&redirect_uri=https://iaagenta360.agentautohome.com/agent&state=profile_A360' 
                : 'https://fwsia.oktapreview.com/oauth2/ausc5e3rowebDIv8F1d7/v1/authorize?client_id=0oac5dnmybCyHJORP1d7&response_type=code&scope=mfa openid offline_access&redirect_uri=https://iaagenta360qa.agentautohome.com/agent&state=profile_A360';
            
            if (result?.farmers_mfa?.includes('MFA Enforced') || result?.farmers_mfa?.includes('MFA Register')) {
                links.unshift({
                    'link': {
                        'url': url,
                        'linkId': 'mfa',
                        'name': {
                        'id': 'ml_sidebar.text.sections.media_sidebar.link3',
                        'defaultMessage': 'Manage Multifactor Authentication Preferences'
                        }
                    }
                })

                setIsMFALinkAdded(true)
            }
        }
    };
    
    if (enabled === true) {
        if (authUserData.userType === MLUserTypes.IA) {
            linksToRender = MLSidebar.configuration.iaLinks;
            addMFALink(linksToRender)
            arsUWSectionToRender = MLSidebar.configuration.arsUWSection; // Agency Resource Center/Underwriting will display for IA and PCS
            claimsSectionToRender = MLSidebar.configuration.claimsSection; // Claims will display for IA, PCS, CSC Sales and Servicing 
        } else if (authUserData.userType === MLUserTypes.PCS) {
            linksToRender = MLSidebar.configuration.pcsLinks;
            arsUWSectionToRender = MLSidebar.configuration.pcsUWSection; // Agency Resource Center/Underwriting will display for IA and PCS
            claimsSectionToRender = MLSidebar.configuration.claimsSection; // Claims will display for IA, PCS, CSC Sales and Servicing
        } else if (authUserData.userType === MLUserTypes.MET_GA) {
            linksToRender = MLSidebar.configuration.fgiaLinks;
            addMFALink(linksToRender);
            arsUWSectionToRender = MLSidebar.configuration.arsUWSection; // Agency Resource Center/Underwriting will display for IA and PCS 
            claimsSectionToRender = MLSidebar.configuration.claimsSection; // Claims will display for IA, PCS, CSC Sales and Servicing
        } else if (authUserData.userType === MLUserTypes.GCS_SALES) {
            linksToRender = MLSidebar.configuration.cscSalesLinks;
            claimsSectionToRender = MLSidebar.configuration.claimsSection; // Claims will display for IA, PCS, CSC Sales and Servicing
            commiSectionToRender = MLSidebar.configuration.commiSection; // Commissions will display for CSC Sales and Servicing
            uwSectionToRender = MLSidebar.configuration.uwSection; // Underwriting will display for CSC Sales and Servicing
        } else if (authUserData.userType === MLUserTypes.GCS_SERVICING) {
            linksToRender = MLSidebar.configuration.cscServiceLinks;
            claimsSectionToRender = MLSidebar.configuration.claimsSection; // Claims will display for IA, PCS, CSC Sales and Servicing
            commiSectionToRender = MLSidebar.configuration.commiSection; // Commissions will display for CSC Sales and Servicing
            uwSectionToRender = MLSidebar.configuration.uwSection; // Underwriting will display for CSC Sales and Servicing
        }

        updateLinks(arsUrl);
        updateSupplySourceLinkForLowerEnv();

        return (
            <Grid className={mediaSidebarStyles.gwMediaSidebarWrapper} gap="none">
                {MLSidebar.enabled && (
                    <React.Fragment>
                        <nav>
                        <h1 className={mediaSidebarStyles.gwMediaSidebarSubheader}>Links</h1>
                        <ul>
                            <MLSidebarLinks linksToRender={linksToRender} key="text" id="mlTextSidebarWidget" />
                        </ul>
                        </nav>
                    </React.Fragment>
                )}
                {MLSidebar.enabled && (
                    <MLSidebarContactSection
                        arsUWSection={arsUWSectionToRender}
                        claimsSection={claimsSectionToRender}
                        commiSection={commiSectionToRender}
                        uwSection={uwSectionToRender}
                    />
                )}
                {showContact && Contact.enabled && (
                    <ContactComponent
                        config={Contact.configuration}
                        key="contact"
                        id="contactSidebarWidget"
                    />
                )}
                {Text.enabled && (
                    <TextComponent config={Text.configuration} key="text" id="textSidebarWidget" />
                )}
                {Rss.enabled && (
                    <RssDirective
                        limit={Rss.configuration.limit}
                        feed={Rss.configuration.feed}
                        key="rss"
                        id="rssSidebarWidget"
                    />
                )}
                {Twitter.enabled && (
                    <TwitterComponent
                        config={Twitter.configuration}
                        key="twitter"
                        id="twitterSidebarWidget"
                    />
                )}
                {Youtube.enabled && (
                    <YoutubeComponent
                        config={Youtube.configuration}
                        key="youtube"
                        id="youtubeSidebarWidget"
                    />
                )}
                {Facebook.enabled && (
                    <FacebookPageComponent
                        config={Facebook.configuration}
                        key="facebook"
                        id="facebookSidebarWidget"
                    />
                )}
            </Grid>
        );
    }


    return null;
}

MediaSideBar.propTypes = {
    showContact: PropTypes.bool
};

MediaSideBar.defaultProps = {
    showContact: _.get(appConfig, 'mediaSidebar.Contact.enabled', false)
};

export default withAuthenticationContext(MediaSideBar);
